import React from 'react';
import { Card, Tabs } from 'antd';
import CostGroupTable from './CostGroupTable';
import CostTypeTable from './CostTypeTable';
import BasePriceTable from './BasePriceTable';
import StorageRateTable from './StorageRateTable';
import StorageTierTable from './StorageTierTable';
import SettingsTable from './SettingsTable';

const FinanceReference = () => {
    return (
        <div style={{ padding: "12px" }}>
            <Card
                title="Finance Reference Data"
                bordered={false}
                bodyStyle={{ padding: "12px" }}
            >
                <Tabs
                    defaultActiveKey="1"
                    size="small"
                    tabBarStyle={{ marginBottom: 12 }}
                    items={[
                        { key: "1", label: "Grup Biaya", children: <CostGroupTable /> },
                        { key: "2", label: "Biaya (Layanan)", children: <CostTypeTable /> },
                        { key: "3", label: "Harga Dasar", children: <BasePriceTable /> },
                        { key: "4", label: "Tarif Kategori", children: <StorageRateTable /> },
                        // { key: "5", label: "Tiering Storage", children: <StorageTierTable /> },
                        { key: "6", label: "Setting Nomor Invoice", children: <SettingsTable /> },
                    ]}
                />
            </Card>
        </div>
    );
};

export default FinanceReference;
